"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, find, findIn, findAllIn, closest, removeAttribute, setAttribute} from "@elements/dom-utils";
import axios from "axios";
import asyncAppend from "@elements/async-append";

export function init () {
    onFind('.js-customer-pricelist', container => {
        let button = findIn('.js-customer-pricelist-check', container);
        let download = findIn('.js-customer-pricelist-download', container);
        let fileTypeRadio = findIn('.js-customer-pricelist__filetype', container);
        let url = button.getAttribute('data-check-status-url');

        on('click', evt => {
            let loading = findIn('.js-customer-pricelist__loading', download);
            removeAttribute('hidden', loading);

            let fileType;
            findAllIn('input', fileTypeRadio).map((input) => {
                if(input.checked){
                    fileType = input.value;
                }
            });

            let params = new URLSearchParams({
                fileType: fileType
            });

           let myInterval = setInterval(() => {

               let pendingRequest = axios({method: 'GET', url: url, responseType: 'json', params: params});
               pendingRequest.then((response) => {

                    let available = response.data.available;
                    let inProgress = response.data.inProgress;

                    if(available === true && inProgress === false) {

                        let downloadUrl = download.getAttribute('data-pricelist-download');

                        let pendingRequest = axios({
                            method: 'GET',
                            url: downloadUrl,
                            params: params
                        });

                        asyncAppend({
                            target: findAllIn('.js-customer-pricelist__result', download),
                            loading: findAllIn('.js-customer-pricelist__loading', download)
                        }, pendingRequest.then((x) => x.data));

                        clearInterval(myInterval);
                    }
               }).catch(e => {console.warn(e);});
           }, 5000);
       }, button);
    });
}